import React from 'react';
import Navigation from './Navigation';
import InactivityTracker from './InactivityTracker';

/**
 * SharedLayout - A consistent layout wrapper for all protected routes
 * This component ensures consistent navigation sidebar positioning and content alignment
 * across all pages in the application.
 * 
 * This component will override any conflicting layout styles in child components
 * to ensure consistent sidebar and content alignment across the entire app.
 */
const SharedLayout = ({ children }) => {
  // Use React.Children to modify children if needed
  const wrappedChildren = React.Children.map(children, child => {
    // If child is not a valid React element, return as is
    if (!React.isValidElement(child)) return child;
    
    // Return the child as is - our wrapper div will handle the layout
    return child;
  });

  return (
    <div className="h-screen overflow-hidden">
      {/* Fixed sidebar navigation */}
      <Navigation />
      
      {/* Main content area - ensure consistent left margin with no gap */}
      <div className="md:ml-64 h-full overflow-auto">
        <InactivityTracker />
        
        {/* Content wrapper - allow full width for all children */}
        <div className="w-full" style={{ maxWidth: 'none !important' }}>
          {wrappedChildren}
        </div>
      </div>
    </div>
  );
};

export default SharedLayout;
